/**
 * Build-time brand defaults.
 *
 * The authoritative name is served at runtime by `GET /meta/config`, but three
 * things are decided before that response can arrive: the `<title>` baked into
 * index.html, the tab title during the initial paint, and the name shown if the
 * API is unreachable. They all read this constant, so there is exactly one
 * literal in the frontend rather than one per surface.
 *
 * Override per build with `VITE_APP_NAME` (see Dockerfile / .env.example). This
 * file is imported by both `vite.config.ts` (Node, pre-bundle) and
 * `src/config.ts` (browser), so it must stay dependency-free.
 */
export const DEFAULT_APP_NAME = "Zamzam";
